import * as Actions from "../constants/CartConstants";

const InitialState = {
	cartItems: [],
	cartPrice: 0,
	itemsCount: 0,
    isCartValid: true,
	invalidCartItems: [],
	discardedCart: {},
	showDiscardedItemsError: false
};

export const Cart = (state = InitialState, action: any) => {
	switch (action.type) {
		case Actions.SET_CART:

			const { showDiscardedItemsError, isCartValid, invalidCartItems } = state;

			return {
				showDiscardedItemsError,
				isCartValid,
				invalidCartItems,
				...action.data
			};

		case Actions.CLEAR_CART:
			return {
				...InitialState,
			};

		case Actions.SET_COUPONS:
			return {
				...state,
				coupons: action.data,
			};

		case Actions.UPDATE_DISCARDED_CART:
			return {
				...state,
				discardedCart : {
					...state.discardedCart,
					...action.data
				}
			}

		case Actions.SOFT_UPDATE_CART: 
			return {
				...state,
				...action.data
			}

		default:
			return {
				...state,
			};
	}
};

export default Cart;
